/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

const styles = {
  valueProps: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-50);
    padding: 0;
    margin: 0;
    list-style-type: none;
  `,
  valuePropListItem: css`
    display: flex;
    align-items: flex-start;
    gap: var(--cds-spacing-50);
  `,
  checkMark: css`
    flex-shrink: 0;
  `,
};

type PropsFromCaller = {
  valueProps: string[];
};

const S12nFreeTrialRemovalValueProps = ({ valueProps }: PropsFromCaller) => (
  <ul css={styles.valueProps}>
    {valueProps.map((valueProp) => (
      <li key={`value-prop-${valueProp}`} css={styles.valuePropListItem}>
        <CheckIcon size="medium" color="interactive" css={styles.checkMark} />
        <Typography2 component="p">{valueProp}</Typography2>
      </li>
    ))}
  </ul>
);

export default S12nFreeTrialRemovalValueProps;
